import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import config from '../config';

function FestivalList() {
    const [festivals, setFestivals] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [search, setSearch] = useState('');

    useEffect(() => {
        document.title = 'SHARC - Festivals';
        axios.get(`${config.API_URL}/festivals`)
            .then(res => {
                setFestivals(res.data.festivals || []);
                setLoading(false);
            })
            .catch(() => {
                setError('Failed to load festivals');
                setLoading(false);
            });
        return () => { document.title = 'SHARC - Shows Archive'; };
    }, []);

    const formatDate = (dateStr) => {
        if (!dateStr) return null;
        return new Date(dateStr).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' });
    };

    const q = search.toLowerCase();
    const filtered = search
        ? festivals.filter(f => [f.name, f.description].some(v => v && v.toLowerCase().includes(q)))
        : festivals;

    if (loading) return <div style={styles.message}>Loading festivals...</div>;
    if (error) return <div style={styles.error}>{error}</div>;

    return (
        <div>
            <div style={styles.headerRow}>
                <h1 style={styles.pageTitle}>Festivals</h1>
                <Link to="/add-festival" style={styles.addButton}>+ Add Festival</Link>
            </div>

            <input
                type="text"
                placeholder="Search festivals..."
                value={search}
                onChange={e => setSearch(e.target.value)}
                style={styles.search}
            />

            {filtered.length === 0 ? (
                <div style={styles.empty}>
                    {search ? 'No festivals match your search.' : 'No festivals recorded yet.'}
                </div>
            ) : (
                <div style={styles.tableContainer}>
                    <table style={styles.table}>
                        <thead>
                            <tr>
                                <th style={styles.th}>Festival</th>
                                <th style={styles.th}>Dates</th>
                                <th style={styles.th}>Events</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filtered.map((f, idx) => {
                                const start = formatDate(f.start_date);
                                const end = formatDate(f.end_date);
                                const dateRange = start && end && start !== end
                                    ? `${start} – ${end}`
                                    : start || '—';

                                return (
                                    <tr key={f.id} style={idx % 2 === 0 ? styles.trEven : styles.trOdd}>
                                        <td style={styles.td}>
                                            <Link to={`/festivals/${f.slug || f.id}`} style={styles.tableLink}>
                                                {f.name}
                                            </Link>
                                        </td>
                                        <td style={styles.td}>{dateRange}</td>
                                        <td style={styles.td}>
                                            <span style={styles.badge}>{f.event_count}</span>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
}

const styles = {
    headerRow: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' },
    pageTitle: { fontSize: '32px', fontWeight: 'bold', color: '#e0e0e0', margin: 0 },
    addButton: { backgroundColor: '#bb86fc', color: '#121212', textDecoration: 'none', padding: '8px 18px', borderRadius: '4px', fontSize: '14px', fontWeight: 'bold' },
    search: { backgroundColor: '#2c2c2c', border: '1px solid #444', borderRadius: '6px', padding: '10px 14px', fontSize: '14px', color: '#e0e0e0', width: '100%', marginBottom: '24px', boxSizing: 'border-box' },
    tableContainer: { overflowX: 'auto' },
    table: { width: '100%', borderCollapse: 'collapse', fontSize: '14px' },
    th: { textAlign: 'left', padding: '10px 16px', color: '#aaa', fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.5px', borderBottom: '1px solid #333', whiteSpace: 'nowrap' },
    td: { padding: '12px 16px', color: '#e0e0e0', borderBottom: '1px solid #222' },
    trEven: { backgroundColor: '#1e1e1e' },
    trOdd: { backgroundColor: '#1a1a1a' },
    tableLink: { color: '#bb86fc', textDecoration: 'none', fontWeight: 'bold' },
    badge: { backgroundColor: '#2c2c2c', border: '1px solid #444', borderRadius: '4px', padding: '2px 8px', fontSize: '13px', color: '#bb86fc', fontWeight: 'bold' },
    empty: { textAlign: 'center', color: '#666', padding: '60px 0', fontSize: '15px' },
    message: { textAlign: 'center', color: '#aaa', fontSize: '16px', padding: '60px 0' },
    error: { textAlign: 'center', color: '#cf6679', fontSize: '16px', padding: '60px 0' },
};

export default FestivalList;
